module.exports = __webpack_public_path__ + "img/doc.d4fbfe45.svg";